<template>
  <v-container fluid>
    <!-- Sezione Certificazioni -->
    <v-row>
      <!-- Tipo di Certificazione -->
      <v-col cols="12" md="2">
        <span class="text-subtitle-1">Tipo di Certificazione:</span>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-checkbox :disabled="cliente.certificazioneFSCG" v-model="cliente.certificazioneFSCS" label="FSC (singola)"
          color="primary" hide-details @change="notificaAggiornamento" />
        <v-checkbox :disabled="cliente.certificazioneFSCS" v-model="cliente.certificazioneFSCG" label="FSC (gruppo)"
          color="primary" hide-details @change="notificaAggiornamento" />
        <v-checkbox :disabled="cliente.certificazionePEFCG" v-model="cliente.certificazionePEFC"
          label="PEFC (singola)" color="primary" hide-details @change="notificaAggiornamento" />
        <v-checkbox :disabled="cliente.certificazionePEFC" v-model="cliente.certificazionePEFCG" label="PEFC (gruppo)"
          color="primary" hide-details @change="notificaAggiornamento" />
        <v-checkbox v-model="cliente.certificazioneFPC" label="FPC" color="primary" hide-details
          @change="notificaAggiornamento" />
        <v-checkbox v-model="cliente.certificazioneISO" label="ISO" color="primary" hide-details
          @change="notificaAggiornamento" />
      </v-col>

      <!-- Codici Certificazione -->
      <v-col cols="12" sm="6" md="4">
        <v-text-field :disabled="!cliente.certificazioneFSCS" class="mb-5" v-model="cliente.codiceFSCS" dense
          hide-details label="Codice certificazione FSC (singola)" clearable />
        <v-text-field :disabled="!cliente.certificazioneFSCG" class="mb-5" v-model="cliente.codiceFSCG" dense
          hide-details label="Codice certificazione FSC (gruppo)" clearable />
        <v-text-field :disabled="!cliente.certificazionePEFC" class="mb-5" v-model="cliente.codicePEFC" dense
          hide-details label="Codice certificazione PEFC singola" clearable />
        <v-text-field :disabled="!cliente.certificazionePEFCG" class="mb-5" v-model="cliente.codicePEFCG" dense
          hide-details label="Codice certificazione PEFC gruppo" clearable />
        <v-text-field :disabled="!cliente.certificazioneFPC" class="mb-4" v-model="cliente.codiceFPC" dense
          hide-details label="Codice certificazione FPC" clearable />
        <v-text-field :disabled="!cliente.certificazioneISO" v-model="cliente.codiceISO" dense hide-details
          label="Codice certificazione ISO" clearable />
      </v-col>

      <!-- Date Audit -->
      <v-col cols="12" md="3">
        <!-- Data Audit FSC Singola -->
        <campo-data :disabled="!cliente.certificazioneFSCS" v-model="cliente.dataAuditFSCS"
          label="Data Audit FSC (singola)" class-custom="mb-4" />

        <!-- Data Audit FSC Gruppo -->
        <campo-data :disabled="!cliente.certificazioneFSCG" v-model="cliente.dataAuditFSCG"
          label="Data Audit FSC (gruppo)" class-custom="mb-4" />

        <!-- Data Audit PEFC Singola -->
        <campo-data :disabled="!cliente.certificazionePEFC" v-model="cliente.dataAuditPEFC"
          label="Data Audit PEFC (singola)" class-custom="mb-4" />

        <!-- Data Audit PEFC Gruppo -->
        <campo-data :disabled="!cliente.certificazionePEFCG" v-model="cliente.dataAuditPEFCG"
          label="Data Audit PEFC (gruppo)" class-custom="mb-4" />

        <!-- Data Audit FPC -->
        <campo-data :disabled="!cliente.certificazioneFPC" v-model="cliente.dataAuditFPC" label="Data Audit FPC"
          class-custom="mb-4" />

        <!-- Data Audit ISO -->
        <campo-data :disabled="!cliente.certificazioneISO" v-model="cliente.dataAuditISO" label="Data Audit ISO" />
      </v-col>
    </v-row>

    <!-- Responsabili -->
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field v-model="cliente.respCoc" hide-details dense label="Responsabile Coc" clearable />
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field v-model="cliente.respFPC" dense hide-details label="Responsabile FPC" clearable />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CampoData from "./CampoData.vue";

export default {
  name: "DatiCertificazioni",

  components: {
    CampoData,
  },

  props: {
    cliente: {
      type: Object,
      required: true,
    },
  },

  methods: {
    notificaAggiornamento() {
      this.$emit("update");
    },
  },
};
</script>
